import {
  InfoModule,
  createInfoServices
} from "./chunk-5V3GS4D5.mjs";
import "./chunk-FOHPRMQF.mjs";
export {
  InfoModule,
  createInfoServices
};
